const promoJson = [
  {
    pid: "2120",
    originalPrice: "319",
    discountPrice: "299",
    code: "gadword_re_or_pl",
  },
  {
    pid: "1850",
    originalPrice: "319",
    discountPrice: "459",
    code: "ppc_re_mi_pl_broker",
  },
  {
    pid: "1853",
    originalPrice: "319",
    discountPrice: "399",
    code: "ppc_re_mi_pl_broker",
  },
];
let promoCookieJson;

function readCookie(name) {
  let nameEQ = encodeURI(name) + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0)
      return decodeURI(c.substring(nameEQ.length, c.length));
  }
  return null;
}

function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toGMTString();
  }
  const domain =
    location.hostname == "localhost"
      ? ""
      : ";domain=." +
        location.hostname.split(".").reverse()[1] +
        "." +
        location.hostname.split(".").reverse()[0];
  const security =
    location.hostname == "localhost" ? "" : ";SameSite=None; Secure";
  document.cookie =
    name + "=" + value + expires + ";path=/" + domain + security;
}

function getQueryString(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function applyPromoPrice(regLink, regLinkHref, promoJson) {
  if (promoJson.pid === getQueryString("id", regLinkHref)) {
    //if promo item equals anchor query string id
    let costBannerEl = regLink.closest(".card");
    let newPrice = regLink.previousElementSibling;
    if (costBannerEl) {
      // applied to cards on landing pages only
      costBannerEl = costBannerEl.querySelector(".cost-banner");
      costBannerEl.classList.add("promo");
      costBannerEl.innerHTML = `<span class="cost">$${promoJson.originalPrice}</span><span class="discount">$${promoJson.discountPrice}</span>`;
    } else if (newPrice) {
      // applied to regular price format
      newPrice.innerHTML = `<span class="dollar-sign">$</span><span class="dollars">${promoJson.discountPrice}</span><span class="slashprice">$${promoJson.originalPrice}</span>`;
    }
  }
}

function modifyRegUrlAndPrice() {
  const regLinks = [
    ...document.querySelectorAll("a[href*='anet_store/register.php']"),
  ];
  regLinks.forEach((regLink) => {
    //loop through all reg links
    let regHref = regLink.href;
    let regUrl = new URL(regHref);
    let regQueryStringId = getQueryString("id", regHref);
    if (getQueryString("src", window.location.href) != null) {
      //if src query string of current URL != null
      promoJson.forEach((promoItem) => {
        //for each item in promoJson at the top of file
        if (
          getQueryString("src", regHref) != null ||
          regQueryStringId != promoItem.pid
        ) {
          regHref = regHref;
        } else {
          regUrl.search !== ""
            ? (regHref = regHref + "&src=" + promoItem.code)
            : (regHref = regHref + "?src=" + promoItem.code); //update regUrl with query string so pricing works in cart
          if (
            readCookie(`aypore_promo${promoItem.pid}`) == null ||
            readCookie(`aypore_promo${promoItem.pid}`) !=
              JSON.stringify(promoItem)
          ) {
            //if cookie doesn't already exist or new promotional value exists for the pid
            setCookie(
              `aypore_promo${promoItem.pid}`,
              JSON.stringify(promoItem),
              60
            ); //set specific cookie
          }
        }
      });
    }
    if (readCookie(`aypore_promo${regQueryStringId}`)) {
      //if cookie exists
      promoCookieJson = JSON.parse(
        readCookie(`aypore_promo${regQueryStringId}`)
      ); //parse json from cookie
      applyPromoPrice(regLink, regHref, promoCookieJson);

      if (
        getQueryString("src", regHref) != null ||
        getQueryString("id", regHref) != promoCookieJson.pid
      ) {
        regHref = regHref;
      } else {
        regUrl.search !== ""
          ? (regHref = regHref + "&src=" + promoCookieJson.code)
          : (regHref = regHref + "?src=" + promoCookieJson.code); //update regUrl with query string so pricing works in cart
      }
    }

    regLink.href = regHref;
    //  console.log(href);
  });
}

modifyRegUrlAndPrice();
